export default class FragmentsContext {
    private static contextRoute: string = 'app';

    public static init(){
        let q = document.querySelector('meta[name="context-route"]');
        if(q){
            FragmentsContext.contextRoute =  q.getAttribute('content');
        }
    }

    public static route():string{
        return FragmentsContext.contextRoute;
    }
}
